import { Button, Input, Modal } from "antd";
import React, { useState } from "react";
import { svg } from "../../../../Assets/svg";
import * as Yup from "yup";
import { useAppDispatch } from "../../../../store";
import { useFormik } from "formik";
import { createColorAPI, updateColorAPI } from "./colorsApis";

interface Props {
  open: boolean;
  onClose: () => void;
  refreshData: () => void;
  editData?: any | null;
}

const AddColorModal = ({ open, onClose, refreshData, editData }: Props) => {
  const dispatch = useAppDispatch();
  const [saving, setSaving] = useState(false);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: editData?.name ?? null,
      powder_coating_price: editData?.powder_coating_price ?? null,
      changeover_price: editData?.changeover_price ?? null,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Product Type is required"),
      powder_coating_price: Yup.number()
        .min(0, "Powder Coating Price must be greater than or equal to 0")
        .required("Powder Coating Price is required"),
      changeover_price: Yup.number()
        .min(0, "Changeover Price must be greater than or equal to 0")
        .required("Changeover Price is required"),
    }),
    onSubmit: (values) => {
      const payload = {
        ...(editData?._id && { id: editData?._id }),
        name: values?.name,
        powder_coating_price: Number(values?.powder_coating_price),
        changeover_price: Number(values?.changeover_price),
        // ...(values?.powder_coating_price && {
        //   powder_coating_price: Number(values?.powder_coating_price),
        // }),
        // ...(values?.changeover_price && {
        //   changeover_price: Number(values?.changeover_price),
        // }),
      };

      setSaving(true);

      if (editData?._id) {
        dispatch(
          updateColorAPI({
            payload,
            onSuccess: () => {
              setSaving(false);
              refreshData();
              onClose();
            },
            onError: () => {
              setSaving(false);
            },
          }),
        );
      } else {
        dispatch(
          createColorAPI({
            payload,
            onSuccess: () => {
              setSaving(false);
              refreshData();
              onClose();
            },
            onError: () => {
              setSaving(false);
            },
          }),
        );
      }
    },
  });
  return (
    <Modal
      open={open}
      centered
      width={"33.75rem"}
      footer={null}
      onCancel={onClose}
      closeIcon={svg?.closeIcon}
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          {editData
            ? "Update Powder Coating Colour"
            : "Create Powder Coating Colour"}
        </div>
      }
      className="commonModalClass"
    >
      <form
        className="page-form d-flex flex-column gap-3"
        onSubmit={formik.handleSubmit}
      >
        <div className="d-flex flex-column gap-3">
          <div>
            <label className="custom-label mb-1 ff">Name</label>
            <Input
              name="name"
              placeholder="Name"
              value={formik?.values?.name}
              onChange={formik.handleChange}
              className="form-control form-control-lg"
            />
            {formik.errors.name && formik.touched.name && (
              <span className="text-danger">
                {formik.errors.name as React.ReactNode}
              </span>
            )}
          </div>
          <div>
            <label className="custom-label mb-1 ff">Powder Coating Price</label>
            <Input
              name="powder_coating_price"
              placeholder="Powder Coating Price"
              type="text"
              value={formik?.values?.powder_coating_price}
              onChange={(e) => {
                let val = e.target.value.replace(/[^0-9.]/g, "");
                const parts = val.split(".");
                if (parts.length > 2)
                  val = parts[0] + "." + parts.slice(1).join("");
                formik.setFieldValue("powder_coating_price", val);
              }}
              className="form-control form-control-lg"
              prefix={<span>£/Kg</span>}
            />
            {formik.errors.powder_coating_price &&
              formik.touched.powder_coating_price && (
                <span className="text-danger">
                  {formik.errors.powder_coating_price as React.ReactNode}
                </span>
              )}
          </div>
          <div>
            <label className="custom-label mb-1 ff">Changeover Price</label>
            <Input
              name="changeover_price"
              placeholder="Changeover Price"
              type="text"
              value={formik?.values?.changeover_price}
              onChange={(e) => {
                let val = e.target.value.replace(/[^0-9.]/g, "");
                const parts = val.split(".");
                if (parts.length > 2)
                  val = parts[0] + "." + parts.slice(1).join("");
                formik.setFieldValue("changeover_price", val);
              }}
              className="form-control form-control-lg"
              prefix={<span>£</span>}
            />
            {formik.errors.changeover_price &&
              formik.touched.changeover_price && (
                <span className="text-danger">
                  {formik.errors.changeover_price as React.ReactNode}
                </span>
              )}
          </div>
          <div className="d-flex justify-content-center gap-3 mt-4">
            <Button
              onClick={onClose}
              disabled={saving}
              className="btn btn-lg btn-outline-secondary h-auto px-5"
            >
              CLOSE
            </Button>

            <Button
              loading={saving}
              htmlType="submit"
              className="btn btn-lg btn-primary h-auto px-5"
            >
              {editData ? "UPDATE" : "SAVE"}
            </Button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default AddColorModal;
